export const mutations = {
  MutationSetBannerItems(state, bannerItems) {
    state.bannerItems = bannerItems;
  },
  MutationSetBannerItemsLoadingStatus(state, status) {
    state.bannerItemsLoadingStatus = status;
  },
  MutationSetBannerDetail(state, bannerDetail) {
    state.bannerDetail = bannerDetail;
  },
  MutationSetBannerDetailLoadingStatus(state, status) {
    state.bannerDetailLoadingStatus = status;
  },
};
